var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-inner-loading',{staticClass:"z-max",attrs:{"showing":_vm.showLoading}},[_c('q-spinner-gears',{attrs:{"size":"4rem","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }